try {
    document.addEventListener('DOMContentLoaded', function() {
    const timeoutDuration = 5000;
    
    const observer = new MutationObserver((mutationsList, observer) => {
        const checkboxes = document.querySelectorAll('.rbr-checkbox-input:not([aria-label])');
        if (checkboxes.length > 0) {
          checkboxes.forEach(cb => cb.setAttribute('aria-label', 'Checkbox'));
        }
      });
    observer.observe(document.body, { childList: true, subtree: true });

    const timeoutId = setTimeout(() => {
        observer.disconnect();
    }, timeoutDuration);
  }); 
} catch (error) { }


try {
  document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('a[rel="noreferrer"][target="_blank"]').forEach(link => {
        // Skip if it already has an aria-label
        if (link.getAttribute('aria-label')) return;
  
        // Try to find the product title from the previous sibling or parent node
        let label = '';
  
        const prevText = link.parentElement?.querySelector('span');
        if (prevText && prevText.textContent.trim()) {
          label = prevText.textContent.trim();
        }
  
        // Fallback label
        if (!label) {
          label = 'Product link';
        }
  
        // Apply label
        link.setAttribute('aria-label', label);
      });
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  
    // Optional timeout to stop the observer after 5 seconds
    setTimeout(() => observer.disconnect(), 5000);
  });
} catch (error) { }